// loader.interceptor.ts
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";
import { AppStateService } from "@services/index";
import { Observable } from "rxjs";
import { finalize } from "rxjs/operators";
import { SILENT_REQUEST } from "./silent-request.token";

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private appStateService: AppStateService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isApiUrl = req.url.startsWith(environment.backendURL);
    // Exclude autocomplete and search endpoints from showing loader, plus
    // background status polls. A poll that raises the global loader makes the
    // whole page flash on every tick — for a long-running job that is every few
    // seconds for as long as it runs.
    const isExcludedUrl =
      req.url.includes("/autocomplete") ||
      req.url.includes("/search") ||
      req.url.includes("/tags/autocomplete") ||
      req.url.includes("/product-sections/status") ||
      // Requests sent with RequestService `{ silent: true }` (Messages polls, presigned
      // image URLs).
      req.context.get(SILENT_REQUEST);

    if (isApiUrl && !isExcludedUrl) {
      this.appStateService.apiLoading$.next(true);
    }

    return next.handle(req).pipe(
      finalize(() => {
        if (isApiUrl && !isExcludedUrl) {
          this.appStateService.apiLoading$.next(false);
        }
      })
    );
  }
}
